<template>
  <div class="base-info">
    <div class="year">
      <span>高考年份</span>
      <el-select v-model="localValue" placeholder="请选择年份" @change="selectChanged">
        <el-option v-for="(item, index) in yearOptions" :key="index" :label="item.code" :value="item.code"> </el-option>
      </el-select>
    </div>

    <div v-if="localPolicy == 0" class="subjects">
      <div class="title">
        <div>首选科目</div>
        <div class="tip">(2选1)</div>
      </div>
      <div class="subject">
        <div
          v-for="(item, index) in localKemLists"
          :key="index"
          :class="item.CR ? 'item active' : 'item'"
          @click="cliSub(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <div v-if="localPolicy == 1" class="subjects">
      <div class="title">
        <div>选择科目</div>
        <div class="tip">(6选3)</div>
      </div>
      <div class="subject">
        <div
          v-for="(item, index) in localKemLists"
          :key="index"
          :class="item.CR ? 'item active' : 'item'"
          @click="cliSub(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <div v-if="localPolicy == 2" class="subjects">
      <div class="title">
        <div>选择科目</div>
        <div class="tip">(7选3)</div>
      </div>
      <div class="subject">
        <div
          v-for="(item, index) in localKemLists"
          :key="index"
          :class="item.CR ? 'item active' : 'item'"
          @click="cliSub(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <div v-if="localPolicy == 3" class="policy-subjects">
      <div class="subjects policy-block">
        <div class="title">
          <div>首选科目</div>
          <div class="tip">(2选1)</div>
        </div>
        <div class="subject">
          <div
            v-for="(item, index) in localKemLists"
            :key="index"
            v-show="item.isfirst == 'true'"
            :class="item.CR ? 'item active' : 'item'"
            @click="cliSub(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="subjects">
        <div class="title">
          <div>次选科目</div>
          <div class="tip">(4选2)</div>
        </div>
        <div class="subject">
          <div
            v-for="(item, index) in localKemLists"
            :key="index"
            v-show="item.isfirst == 'false'"
            :class="item.CR ? 'item active' : 'item'"
            @click="cliSub(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>

    <div class="score">
      <span>预估总分</span>
      <el-input
        :disabled="scoreCount == 0"
        :value="localScore"
        type="number"
        placeholder="请输入分数1-750"
        @input="updateScore"
      ></el-input>
      <div class="f">分</div>
    </div>
  </div>
</template>

<script>
import { request2 } from "@/utils/request";

const RULES_URL = "https://api.static.ycymedu.com/api/v1/base/rules.json";

export default {
  name: "BaseInfo",
  props: {
    provinceObj: {
      type: Object,
      default: () => ({}),
    },
    year: {
      type: [Number, String],
      default: "",
    },
    policy: {
      type: Number,
      default: 0,
    },
    score: {
      type: [Number, String],
      default: "",
    },
    subjectGroup: {
      type: [Array, String],
      default: "",
    },
    scoreCount: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      localValue: this.normalizeValue(this.year),
      localPolicy: this.normalizePolicy(this.policy),
      localScore: this.normalizeScore(this.score),
      localKemLists: [],
      rulesRequestId: 0,
    };
  },
  computed: {
    yearOptions() {
      return Array.isArray(this.provinceObj.lizations)
        ? this.provinceObj.lizations
        : [];
    },
  },
  watch: {

    year(newVal) {
      const normalizedValue = this.normalizeValue(newVal);
      if (String(normalizedValue) !== String(this.localValue)) {
        this.localValue = normalizedValue;
        this.syncFromProps();
      }
    },
    policy(newVal) {
      const normalizedPolicy = this.normalizePolicy(newVal);
      if (normalizedPolicy !== this.localPolicy) {
        this.localPolicy = normalizedPolicy;
        this.syncFromProps();
      }
    },
    score(newVal) {
      const normalizedScore = this.normalizeScore(newVal);
      if (normalizedScore !== this.localScore) {
        this.localScore = normalizedScore;
      }
    },
    subjectGroup() {
      this.syncSubjectGroupState();
    },
  },
  methods: {
    normalizeValue(value) {
      return value === null || value === undefined ? "" : value;
    },
    normalizePolicy(value) {
      const normalizedValue = Number(value);
      return Number.isNaN(normalizedValue) ? 0 : normalizedValue;
    },
    normalizeScore(value) {
      return value === null || value === undefined ? "" : value;
    },
    parseSubjectGroup(subjectGroup = this.subjectGroup) {
      if (Array.isArray(subjectGroup)) {
        return subjectGroup.filter(Boolean);
      }

      return String(subjectGroup || "")
        .split(",")
        .filter(Boolean);
    },
    getYearOption(year = this.localValue) {
      return this.yearOptions.find((item) => String(item.code) === String(year));
    },
    syncFromProps(shouldFetchRules = false) {
      if (!this.yearOptions.length) {
        this.localKemLists = [];
        return;
      }

      const matchedYearOption = this.getYearOption(this.year);
      const fallbackYearOption = matchedYearOption || this.yearOptions[0];
      const nextValue = matchedYearOption
        ? matchedYearOption.code
        : fallbackYearOption.code;
      const nextPolicy = this.normalizePolicy(
        matchedYearOption ? matchedYearOption.Policy : fallbackYearOption.Policy
      );
      const valueChanged = String(this.localValue) !== String(nextValue);
      const policyChanged = this.localPolicy !== nextPolicy;

      this.localValue = nextValue;
      this.localPolicy = nextPolicy;
      this.localScore = this.normalizeScore(this.score);
      this.syncToParent();

      if (shouldFetchRules || valueChanged || policyChanged || !this.localKemLists.length) {
        this.getRules();
        return;
      }

      this.applySubjectGroup();
      this.emitSelectionChange();
    },
    syncSubjectGroupState() {
      if (!this.localKemLists.length) {
        if (this.yearOptions.length) {
          this.getRules();
        }
        return;
      }

      this.applySubjectGroup();
      this.emitSelectionChange();
    },
    async ensureSubjectListReady(force = false) {
      if (!this.yearOptions.length) {
        return;
      }

      if (force || !this.localKemLists.length) {
        await this.getRules();
        return;
      }

      this.applySubjectGroup();
      this.emitSelectionChange();
    },
    syncToParent() {
      this.$emit("update:year", this.localValue);
      this.$emit("update:policy", this.localPolicy);
    },
    applySubjectGroup() {
      if (!this.localKemLists.length) {
        return;
      }

      const selectedSubjectSet = new Set(this.parseSubjectGroup());
      this.localKemLists = this.localKemLists.map((subject) => ({
        ...subject,
        CR: selectedSubjectSet.has(subject.simplename),
      }));
    },
    async getRules() {
      if (!this.yearOptions.length) {
        this.localKemLists = [];
        return;
      }

      const currentRequestId = Date.now();
      this.rulesRequestId = currentRequestId;

      try {
        const res = await request2.get(RULES_URL);

        if (this.rulesRequestId !== currentRequestId) {
          return;
        }

        const list = Array.isArray(res.data.result) ? res.data.result : [];
        this.localKemLists = list
          .filter((item) => item.p === this.localPolicy)
          .map((item) => item.rule)
          .flat()
          .map((rule) => ({ ...rule, CR: false }));

        this.applySubjectGroup();
        this.emitSelectionChange();
      } catch (error) {
        console.error("Request failed:", error);
      }
    },
    selectChanged(yearCode) {
      const matchedYearOption = this.getYearOption(yearCode);

      this.localValue = yearCode;
      this.localPolicy = this.normalizePolicy(
        matchedYearOption ? matchedYearOption.Policy : this.localPolicy
      );

      this.syncToParent();
      this.$emit("update:subjectGroup", "");
      this.getRules();
    },
    updateScore(value) {
      this.localScore = value;
      this.$emit("update:score", this.localScore);
      this.syncToParent();
      this.emitSelectionChange();
    },
    cliSub(subject) {
      const nextKemLists = this.localKemLists.map((item) => ({ ...item }));
      const targetItem = nextKemLists.find(
        (item) =>
          item.code === subject.code &&
          item.simplename === subject.simplename &&
          item.name === subject.name
      );

      if (!targetItem) {
        return;
      }

      if (this.localPolicy == 0) {
        if (targetItem.CR) {
          targetItem.CR = false;
        } else {
          nextKemLists.forEach((item) => {
            item.CR = false;
          });
          targetItem.CR = true;
        }
      } else if (this.localPolicy == 1 || this.localPolicy == 2) {
        const selectedItemsCount = nextKemLists.filter((item) => item.CR).length;

        if (targetItem.CR) {
          targetItem.CR = false;
        } else if (selectedItemsCount < 3) {
          targetItem.CR = true;
        } else {
          this.$message({
            showClose: true,
            message: "最多只能选择3个科目",
            type: "warning",
          });
          return;
        }
      } else if (this.localPolicy == 3) {
        const selectedFirstItems = nextKemLists.filter(
          (item) => item.isfirst === "true" && item.CR
        );
        const selectedOtherItems = nextKemLists.filter(
          (item) => item.isfirst === "false" && item.CR
        );

        if (targetItem.isfirst === "true") {
          if (targetItem.CR) {
            targetItem.CR = false;
          } else {
            selectedFirstItems.forEach((item) => {
              item.CR = false;
            });
            targetItem.CR = true;
          }
        } else if (targetItem.CR) {
          targetItem.CR = false;
        } else if (selectedOtherItems.length < 2) {
          targetItem.CR = true;
        } else {
          this.$message({
            showClose: true,
            message: "最多只能选择2个科目",
            type: "warning",
          });
          return;
        }
      }

      this.localKemLists = nextKemLists;
      this.emitSelectionChange();
    },
    getSelectionPayload() {
      const selectedItems = this.localKemLists.filter((item) => item.CR);

      return {
        year: this.localValue,
        score: this.localScore,
        policy: this.localPolicy,
        provinceCode: this.provinceObj.Code,
        subjectGroup: selectedItems.map((item) => item.simplename).join(","),
        kemLists: this.localKemLists.map((item) => ({ ...item })),
      };
    },
    emitSelectionChange() {
      const payload = this.getSelectionPayload();

      this.$emit("update:subjectGroup", payload.subjectGroup);
      this.$emit("change", payload);
    },
    checkSelection() {
      const selectedItems = this.localKemLists.filter((item) => item.CR);

      if (!this.localValue || !this.localScore) {
        this.$message({
          showClose: true,
          message: "年份和分数不能为空。",
          type: "warning",
        });
        return false;
      }

      if (this.localPolicy === 0) {
        const selectedSubjects = selectedItems.map((item) => item.name);

        if (
          selectedSubjects.includes("文科") &&
          selectedSubjects.includes("理科")
        ) {
          this.$message({
            showClose: true,
            message: "文理科只能选择一个，请重新选择。",
            type: "warning",
          });
          return false;
        }

        if (selectedItems.length !== 1) {
          this.$message({
            showClose: true,
            message: "请选一个科目（文科或理科）。",
            type: "warning",
          });
          return false;
        }
      }

      if (this.localPolicy === 1 && selectedItems.length !== 3) {
        this.$message({
          showClose: true,
          message: "请从物理、化学、生物、历史、政治、地理中选择3个科目。",
          type: "warning",
        });
        return false;
      }

      if (this.localPolicy === 2 && selectedItems.length !== 3) {
        this.$message({
          showClose: true,
          message: "请从物理、化学、生物、历史、政治、地理、信息技术中选择3个科目。",
          type: "warning",
        });
        return false;
      }

      if (this.localPolicy === 3) {
        const selectedFirstItems = selectedItems.filter(
          (item) => item.isfirst === "true"
        );
        const selectedOtherItems = selectedItems.filter(
          (item) => item.isfirst === "false"
        );

        if (selectedFirstItems.length !== 1) {
          this.$message({
            showClose: true,
            message: "必须选择物理或历史其中一个。",
            type: "warning",
          });
          return false;
        }

        if (selectedOtherItems.length > 2) {
          this.$message({
            showClose: true,
            message: "最多只能选择两个次选科目（化学、生物、政治、地理）。",
            type: "warning",
          });
          return false;
        }

        if (selectedItems.length !== 3) {
          this.$message({
            showClose: true,
            message: "必须选择3个科目。",
            type: "warning",
          });
          return false;
        }
      }

      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.base-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  min-height: 0;

  .year,
  .score {
    display: flex;
    align-items: center;

    > span {
      min-width: 64px;
      margin-right: 18px;
      font-size: 16px;
      color: #333333;
    }
  }

  .year {

    .el-select {
      height: 40px;
      flex: 1;
    }
  }

  .subjects {
    display: flex;
  }

  .policy-block {
    margin-bottom: 5px;
  }

  .title {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 64px;
    margin-right: 18px;
    font-size: 16px;
    color: #333333;
  }

  .tip {
    font-size: 12px;
    color: red;
  }

  .subject {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    cursor: pointer;
  }

  .item {
    min-width: 54px;
    height: 29px;
    padding: 0 5px;
    margin-right: 6px;
    margin-bottom: 6px;
    border: 1px solid #e1e1e1;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 400;
    line-height: 29px;
    text-align: center;
  }

  .active {
    color: #ffffff !important;
    background: linear-gradient(to right, #3370ff, #5bb0ff) !important;
  }

  .score {
    position: relative;

    .el-input {
      position: relative;
      display: inline-block;
      font-size: 14px;
    }

    .f {
      position: absolute;
      top: 8px;
      right: 5px;
      font-size: 16px;
      color: #8a8a8a;
    }
  }
}

::v-deep .el-input__inner {
  padding: 1px 40px !important;
}

::v-deep .year .el-input__inner {
  border: 1px solid #e1e1e1 !important;
  border-radius: 10px;
  padding: 1px 40px !important;
}
</style>
